// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2pL7M","content":"LayoutSettings_content__78qNm"};